export const DAY_MILLISECONDS = 24 * 36e5;

export const daysArray = {
  0: "Sun",
  1: "Mon",
  2: "Tue",
  3: "Wed",
  4: "Thu",
  5: "Fri",
  6: "Sat",
};

export const MONTHS_ARRAY = {
  0: "Jan",
  1: "Feb",
  2: "Mar",
  3: "Apr",
  4: "May",
  5: "Jun",
  6: "Jul",
  7: "Aug",
  8: "Sep",
  9: "Oct",
  10: "Nov",
  11: "Dec",
};

export const DEFAULT_OPTION_SELECT = { label: "Select", value: "none" };

export const COLOUR_CONSTANT = {
  theme: {
    dark: "#301D35",
    medium: "#AF81B9",
    light: "#E6D8E9",
    lightPink: "#dedafb",
    purple: { dark: "#BDB5F8", medium: "#dedafb", light: "#efedfd" },
    green: {
      light: "#e4f9dc",
      dark: "#77e250",
    },
    background: {
      dark: "#080425",
    },
  },
};
